module.exports = __webpack_public_path__ + "img/CY.4a00f04d.svg";